(function(){

  //function to load script
  //url is the url containing the script
  //callback is the function to execute after the script is loaded
  var loadScript = function(url, callback){
 
    var script = document.createElement("script");
    script.type = "text/javascript";

    //internet explorer
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    }
    //other browsers
    else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    //append to the head tag the script
    document.getElementsByTagName("head")[0].appendChild(script);
    
  };

  //code that I want to execute
  var myCode = function($){

/*
  var if_con = $('[name="frame-productSet-167373865011"]').contents().find('html').html();
  if_con = if_con.replaceAll('&lt;sup&gt;&amp;reg;&lt;/sup&gt;', "<span style='font-size: 85%;line-height: 0; position: relative; vertical-align: baseline; top: -0.5em;'>®</span>");      
  $('[name="frame-productSet-167373865011"]').contents().find('html').html(if_con);
*/

/*
       setTimeout(
    function() 
    {
      alert();
      var if_con = $('[name="frame-productSet-167373865011"]').contents().find('html').html();
      if_con = if_con.replaceAll(/<sup>&reg;<\/sup>/g, "");      
      $('[name="frame-productSet-167373865011"]').contents().find('html').html(if_con);
      
      
    }, 3000);*/

    

setTimeout(
    function() 
    {
      //var if_con = $('[name="frame-productSet-167373865011"]').contents().find('html').html();
        
        
        /*if_con.find("sup").each(function() {
          alert();
            if ($(this).html() === "®") {
                $(this).replaceWith(""); // Remove or replace with new content
            }
        });*/

      //if_con = if_con.replaceAll('&lt;sup&gt;&amp;reg;&lt;/sup&gt;', "<span style='font-size: 85%;line-height: 0; position: relative; vertical-align: baseline; top: -0.5em;'>®</span>");      
      //$('[name="frame-productSet-167373865011"]').contents().find('html').html(if_con);

      

      





      
      
}, 3000);

    


    

    $(".mega-child-each-click").click(function(e){
             e.preventDefault();
             window.location = $(this).attr('href');  
          return false;
          //alert($(this).attr('href'));
    });

      
    
    //-------------------------------------
    //BEGIN
	$(".m_accordion__title").on("click", function(e) {

		e.preventDefault();
		var $this = $(this);

		if (!$this.hasClass("m_accordion-active")) {
			$(".m_accordion__content").slideUp(400);
			$(".m_accordion__title").removeClass("m_accordion-active");
			$('.m_accordion__arrow').removeClass('m_accordion__rotate');
		}

		$this.toggleClass("m_accordion-active");
		$this.next().slideToggle();
		$('.m_accordion__arrow',this).toggleClass('m_accordion__rotate');
	});
	//END
    //--------------------------------------
   
  };

  //if we already have jQuery we simply execute our function
  //if jQuery is undefined we load the script using noConflict
  if (typeof jQuery === 'undefined'){
    loadScript('//code.jquery.com/jquery-1.12.4.js', function(){
      jQuery = jQuery.noConflict(true);
      myCode(jQuery);
    });
  } else {
    myCode(jQuery);
  }

})();